import { gray, indigo, white } from '@kmns-internal/furikake/tokens'
import type { SxProps, Theme } from '@mui/material'

/** 表示寸法（px） */
const ROW_NUMBER_COLUMN_WIDTH = 56
const ROW_HEADING_COLUMN_WIDTH = 140
const QUESTION_COLUMN_WIDTH = 180

const cellBorder = `1px solid ${gray[4]}`

/** 全セル共通の寸法・フォント・ボーダー（幅指定を除く） */
const cellBaseSx = {
  p: 1,
  fontSize: 14,
  textAlign: 'center',
  overflowWrap: 'anywhere',
  borderRight: cellBorder,
  borderBottom: cellBorder,
} satisfies SxProps<Theme>

/** 列セル共通のスタイル */
const commonCellSx = {
  ...cellBaseSx,
  width: QUESTION_COLUMN_WIDTH,
  minWidth: QUESTION_COLUMN_WIDTH,
  maxWidth: QUESTION_COLUMN_WIDTH,
} satisfies SxProps<Theme>

/** ヘッダー（列名）セル。表の上端になるため上ボーダーを持つ */
export const headerCellSx = {
  ...commonCellSx,
  fontWeight: 700,
  bgcolor: indigo[1],
  borderTop: cellBorder,
} satisfies SxProps<Theme>

/** 本体セル */
export const bodyCellSx = {
  ...commonCellSx,
  bgcolor: white,
} satisfies SxProps<Theme>

/** 条件を満たさない分岐セル（「ー」表示）。回答対象外であることを示す */
export const inactiveCellSx = {
  ...bodyCellSx,
  bgcolor: gray[1],
  color: gray[5],
} satisfies SxProps<Theme>

/** 先頭列（行番号列）を横スクロール時に固定するスタイル */
const firstColumnSx = {
  ...cellBaseSx,
  position: 'sticky',
  left: 0,
  zIndex: 1,
  width: ROW_NUMBER_COLUMN_WIDTH,
  minWidth: ROW_NUMBER_COLUMN_WIDTH,
  maxWidth: ROW_NUMBER_COLUMN_WIDTH,
} satisfies SxProps<Theme>

/**
 * ヘッダー行の先頭セル（左上の角）。表の一部に見せず背景に溶け込ませる。
 * 右・下ボーダーはヘッダー行の左端・行番号列の上端の線を兼ねる。
 */
export const headerFirstCellSx = {
  ...firstColumnSx,
  bgcolor: gray[1],
} satisfies SxProps<Theme>

/** 本体行の先頭セル（行番号）。表の左端になるため左ボーダーを持つ */
export const bodyFirstCellSx = {
  ...firstColumnSx,
  bgcolor: white,
  borderLeft: cellBorder,
} satisfies SxProps<Theme>

/** 行見出し列。行番号列の右に並べて、横スクロール時も一緒に固定する */
const rowHeadingColumnSx = {
  ...cellBaseSx,
  position: 'sticky',
  left: ROW_NUMBER_COLUMN_WIDTH,
  zIndex: 1,
  width: ROW_HEADING_COLUMN_WIDTH,
  minWidth: ROW_HEADING_COLUMN_WIDTH,
  maxWidth: ROW_HEADING_COLUMN_WIDTH,
} satisfies SxProps<Theme>

export const headerRowHeadingCellSx = {
  ...rowHeadingColumnSx,
  fontWeight: 700,
  bgcolor: indigo[1],
  borderTop: cellBorder,
} satisfies SxProps<Theme>

export const bodyRowHeadingCellSx = {
  ...rowHeadingColumnSx,
  bgcolor: white,
} satisfies SxProps<Theme>
